import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    countryStockCards: {
        id: 'iaso.polio.title.countryStockCards',
        defaultMessage: 'Country stock cards',
    },
    en: { id: 'iaso.users.label.english', defaultMessage: 'English' },
    fr: { id: 'iaso.users.label.french', defaultMessage: 'French' },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    vaccine: {
        id: 'iaso.polio.vaccine',
        defaultMessage: 'Vaccine',
    },
    date: {
        defaultMessage: 'Date',
        id: 'iaso.label.date',
    },
    dosesOut: {
        id: 'iaso.label.doses_out',
        defaultMessage: 'Doses OUT',
    },
    dosesIn: {
        id: 'iaso.label.doses_in',
        defaultMessage: 'Doses IN',
    },
    vialsOut: {
        id: 'iaso.label.vials_out',
        defaultMessage: 'Vials OUT',
    },
    vialsIn: {
        id: 'iaso.label.vials_in',
        defaultMessage: 'Vials IN',
    },
    action: {
        id: 'iaso.label.action',
        defaultMessage: 'Action',
    },
    actionType: {
        id: 'iaso.label.actionType',
        defaultMessage: 'Action type',
    },
    vialsType: {
        id: 'iaso.label.vialsType',
        defaultMessage: 'Vials type',
    },
    forma_vials_used: {
        id: 'iaso.polio.label.forma_vials_used',
        defaultMessage: 'Vials used',
    },
    forma_vials_missing: {
        id: 'iaso.polio.label.forma_vials_missing',
        defaultMessage: 'Vials missing',
    },
    forma_unusable_vials: {
        id: 'iaso.polio.label.forma_unusable_vials',
        defaultMessage: 'Unusable vials',
    },
    broken: {
        id: 'iaso.polio.label.broken',
        defaultMessage: 'Broken',
    },
    unreadable_label: {
        id: 'iaso.polio.label.unreadable_label',
        defaultMessage: 'Unreadable Label',
    },
    physical_inventory_add: {
        id: 'iaso.polio.label.physical_inventory_add',
        defaultMessage: 'Add to Physical inventory',
    },
    physical_inventory_remove: {
        id: 'iaso.polio.label.physical_inventory_remove',
        defaultMessage: 'Remove from Physical inventory',
    },
    stealing: {
        id: 'iaso.polio.label.stealing',
        defaultMessage: 'Theft',
    },
    return: {
        id: 'iaso.polio.label.return_to_supplier',
        defaultMessage: 'Return to supplier',
    },
    missing: {
        id: 'iaso.polio.label.missing',
        defaultMessage: 'Missing',
    },
    vaccine_expired: {
        id: 'iaso.polio.label.vaccine_expired',
        defaultMessage: 'Vaccine expired',
    },
    vvm_reached_discard_point: {
        id: 'iaso.polio.label.vvm_reached_discard_point',
        defaultMessage: 'VM reached discard point',
    },
    incident_report: {
        id: 'iaso.polio.label.incidentReport',
        defaultMessage: 'Incident report',
    },
    destruction_report: {
        id: 'iaso.polio.label.destructionReport',
        defaultMessage: 'Destruction report',
    },
    earmarked_stock__returned: {
        id: 'iaso.polio.label.earmarked_stock__returned',
        defaultMessage: 'Earmaked stock - Returned',
    },
    earmarked_stock__created: {
        id: 'iaso.polio.label.earmarked_stock__created',
        defaultMessage: 'Earmaked stock - Created',
    },
    earmarked_stock__used: {
        id: 'iaso.polio.label.earmarked_stock__used',
        defaultMessage: 'Earmaked stock - Used',
    },
    po_action_type: {
        id: 'iaso.polio.label.po_action_type',
        defaultMessage: 'PO',
    },
    countryBlock: {
        defaultMessage: 'Country block',
        id: 'iaso.polio.label.countryBlock',
    },
    unusable: {
        id: 'iaso.label.unusable',
        defaultMessage: 'Unusable',
    },
    usable: {
        id: 'iaso.label.usable',
        defaultMessage: 'Usable',
    },
    vaccine_arrival_report: {
        id: 'iaso.label.publicVaccineStock.PO',
        defaultMessage: 'PO',
    },
    outgoing_stock_movement: {
        id: 'iaso.label.publicVaccineStock.outgoing_stock_movement',
        defaultMessage: 'Form A',
    },
    all: {
        id: 'iaso.forms.all',
        defaultMessage: 'All',
    },
    totalUnusableDoses: {
        id: 'iaso.label.publicVaccineStock.totalUnusableDoses',
        defaultMessage: 'Stock unusable doses',
    },
    totalUsableDoses: {
        id: 'iaso.label.publicVaccineStock.totalUsableDoses',
        defaultMessage: 'Stock usable doses',
    },
    totalUnusableVials: {
        id: 'iaso.label.publicVaccineStock.totalUnusableVials',
        defaultMessage: 'Stock unusable vials',
    },
    totalUsableVials: {
        id: 'iaso.label.publicVaccineStock.totalUsableVials',
        defaultMessage: 'Stock usable vials',
    },
    totalEarmarkedDoses: {
        id: 'iaso.label.publicVaccineStock.totalEarmarkedDoses',
        defaultMessage: 'Stock of earmarked doses',
    },
    totalEarmarkedVials: {
        id: 'iaso.label.publicVaccineStock.totalEarmarkedVials',
        defaultMessage: 'Stock of earmarked vials',
    },
});
export default MESSAGES;
